export const getMaxFileSizeError = (maxSize) => `Maximum file size (${maxSize} kb) exceeded`;
